/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root, doc) {
  'use strict';
  function start() {
    var box = doc.querySelector('[data-moj-raport]');
    if (!box) return;
    var game = box.getAttribute('data-gra') || '';
    var form = box.querySelector('[data-moj-raport-form]');
    var input = box.querySelector('[name="liczby"]');
    var customWindow = box.querySelector('[name="okno_wlasne"]');
    var wrap = box.querySelector('[data-moj-raport-zapisane]');
    var select = box.querySelector('[data-moj-raport-select]');
    var load = box.querySelector('[data-moj-raport-wczytaj]');
    var status = box.querySelector('[data-moj-raport-status]');
    var key = 'pewniaki:moj-raport:' + game;
    var loadBound = false;
    var extra=[],extraContext=box.querySelector('[data-mr-extra-context]');
    function sameNumbers(a,b){function ns(s){return String(s).trim().split(/[\s,;]+/).map(Number).sort(function(x,y){return x-y;}).join(',');}return ns(a)===ns(b);}
    function showExtra(ns){
      extra=game==='eurojackpot' && Array.isArray(ns) && ns.length===2 && new Set(ns).size===2 && ns.every(function(n){return Number.isInteger(n)&&n>=1&&n<=12;}) ? ns.slice() : [];
      var importA=box.querySelector('[data-mz-import-ref="mr-a"]');
      if(importA){try{var payload=JSON.parse(importA.getAttribute('data-mz-import'));payload.extra=sameNumbers(payload.numbers.join(' '),input.value)?extra.slice():[];importA.setAttribute('data-mz-import',JSON.stringify(payload));}catch(ignore){}}
      if(extraContext){extraContext.hidden=!extra.length;extraContext.textContent=extra.length ? (isEnglish()?jst("ui.734e8b75de90aa64"):jst("ui.a21fb33f4fc3d1bd"))+extra.join(', ')+(isEnglish()?'. This report analyses main numbers only; both pools remain separate in your saved selection and journal.':jst("pages_moj_raport_liczb_js.literal.a141402f2c3a")) : '';}
    }
    input.addEventListener('input',function(){showExtra([]);});
    doc.addEventListener('pewniaki:raport-zestaw-wczytany',function(e){if(e.detail&&e.detail.game===game)showExtra(e.detail.extra);});

    function isEnglish() { return /^en(?:-|$)/i.test((doc.documentElement && doc.documentElement.lang) || ''); }
    function message(name) {
      if (status) status.textContent = isEnglish()
        ? jst("fragment.38d1d79dafaa7d5b") + name + jst("ui.384025c19138d799")
        : jst("ui.5c154da2c444c3b5") + name + jst("pages_moj_raport_liczb_js.literal.e9184d055921");
    }
    function api() {
      return root.PewniakiZestawy && typeof root.PewniakiZestawy.sklep === 'function' ? root.PewniakiZestawy : null;
    }
    function findSet(store, id) {
      return store.lista(game).filter(function (set) { return set.id === id; })[0] || null;
    }
    function fill(set) {
      if (!set) return;
      input.value = set.numbers.join(' ');
      showExtra(set.extra);
      if (select) select.value = set.id;
      message(set.name);
    }
    function refreshSaved() {
      var module = api();
      if (!module || !wrap || !select || !load) return;
      var store = module.sklep();
      if (!store || !store.reguly(game)) return;
      var sets = store.lista(game);
      select.textContent = '';
      sets.forEach(function (set) {
        var option = doc.createElement('option');
        option.value = set.id;
        option.textContent = set.name + ' (' + set.numbers.join(', ') + ')';
        select.appendChild(option);
      });
      wrap.hidden = sets.length === 0;
      if (!loadBound) {
        loadBound = true;
        load.addEventListener('click', function () {
          var current = api(), currentStore = current && current.sklep();
          if (currentStore) fill(findSet(currentStore, select.value));
        });
      }
      if (typeof module.wezPrzekaz === 'function') {
        var transfer = module.wezPrzekaz('raport', game);
        if (transfer) fill(findSet(store, transfer.id));
      }
    }

    try {
      var remembered = JSON.parse(root.localStorage.getItem(key) || 'null');
      var params = new URLSearchParams(root.location.search);
      if (remembered && !params.has('liczby') && !params.has('zrodlo') && !input.value && typeof remembered.liczby === 'string') input.value = remembered.liczby;
      if(remembered && sameNumbers(input.value,remembered.liczby))showExtra(remembered.extra);
      if (remembered && !params.has('okno') && !params.has('okno_wlasne')) {
        if (remembered.okno === 'all') {
          box.querySelectorAll('[name="okno"]').forEach(function (radio) { radio.checked = radio.value === 'all'; });
          if (customWindow) customWindow.value = '';
        } else {
          var N = Number(remembered.okno);
          if (Number.isInteger(N) && N >= 7 && N <= 500) {
          var matched = false;
          box.querySelectorAll('[name="okno"]').forEach(function (radio) { radio.checked = Number(radio.value) === N; matched = matched || radio.checked; });
          if (customWindow) customWindow.value = matched ? '' : String(N);
          }
        }
      }
    } catch (ignore) {}
    if (form) form.addEventListener('submit', function () {
      var checked = box.querySelector('[name="okno"]:checked');
      var N = customWindow && customWindow.value ? customWindow.value : (checked ? checked.value : '50');
      try { root.localStorage.setItem(key, JSON.stringify({liczby: input.value, okno: N,extra:extra})); } catch (ignore) {}
    });
    enhanceReport(box, game, input);
    doc.addEventListener('pewniaki:zestawy-gotowe', refreshSaved);
    doc.addEventListener('pewniaki:zestawy-zmiana', refreshSaved);
    refreshSaved();
  }

  function enhanceReport(box, game, input) {
    var en = /^en(?:-|$)/i.test(doc.documentElement.lang || '');
    var chosen = null, chartData = null;
    var actionStatus = box.querySelector('[data-mr-action-status]');
    var formStatus = box.querySelector('[data-mr-form-status]');
    function say(el, pl, english) { if (el) el.textContent = en ? english : pl; }
    function highlight(n) {
      chosen = chosen === n ? null : n;
      box.querySelectorAll('[data-mr-highlight]').forEach(function (b) {
        var on = Number(b.getAttribute('data-mr-highlight')) === chosen;
        b.setAttribute('aria-pressed', String(on));
        b.classList.toggle('przycisk--glowny', on);
        b.classList.toggle('przycisk--drugi', !on);
      });
      box.querySelectorAll('[data-mr-number-row]').forEach(function (row) {
        row.classList.toggle('bg-tlo2', Number(row.getAttribute('data-mr-number-row')) === chosen);
      });
      box.dispatchEvent(new root.CustomEvent('pewniaki:raport-liczba', {detail: {number: chosen}}));
      say(actionStatus, chosen ? jst("pages_moj_raport_liczb_js.literal.1055456d8157") + chosen + jst("pages_moj_raport_liczb_js.literal.092cce1358c1") : jst("pages_moj_raport_liczb_js.literal.deac3a46b6c7"),
        chosen ? jst("fragment.39ffd55438ce9620") + chosen + jst("ui.7e3c11aa793574fa") : jst("ui.fa1f00fcfb669c38"));
    }
    function wire(selector, fn) { var b = box.querySelector(selector); if (b) { b.hidden = false; b.addEventListener('click', fn); } }
    function loadNumbers(ns) {
      if (!ns.length) { say(formStatus, jst("ui.2f321627980b3831"), jst("ui.62aae38e4f7d4e4f")); return; }
      input.value = ns.join(' ');
      input.dispatchEvent(new Event('input',{bubbles:true}));
      say(formStatus, jst("pages_moj_raport_liczb_js.literal.88b77657962a"), jst("ui.edc7248f67b8532c"));
    }
    wire('[data-mr-copy-b]', function () { var b = box.querySelector('[name="liczby_b"]'); b.value = input.value; b.focus(); });
    if (root.PewniakiObserwowane) {
      wire('[data-mr-load-observed]', function () { loadNumbers(root.PewniakiObserwowane.lista(game)); });
      wire('[data-mr-observe]', function () {
        if (chosen === null) { say(actionStatus, jst("pages_moj_raport_liczb_js.literal.20a4804b325b"), jst("ui.f12ff5a8aa5a78d0")); return; }
        var r = root.PewniakiObserwowane.dodaj(game, chosen);
        say(actionStatus, r.ok ? jst("fragment.c23e0086f680a88e") + chosen + jst("ui.63795aceee89409a") : (r.powod === 'juz' ? jst("pages_moj_raport_liczb_js.literal.bbe05e61eb97") : jst("pages_moj_raport_liczb_js.literal.7c5f5caec730")),
          r.ok ? jst("fragment.39ffd55438ce9620") + chosen + jst("ui.582a27d81bfd612c") : (r.powod === 'juz' ? jst("ui.5d84e87138f66851") : jst("ui.78bd486d85157497")));
      });
    }
    if (root.PewniakiSzkic && root.PewniakiSzkic.reguly(game)) {
      wire('[data-mr-load-draft]', function () { loadNumbers(root.PewniakiSzkic.lista(game)); });
      wire('[data-mr-draft]', function () {
        if (chosen === null) { say(actionStatus, jst("pages_moj_raport_liczb_js.literal.f98a0b071753"), jst("ui.960482637aca7238")); return; }
        var r = root.PewniakiSzkic.przelacz(game, chosen, 'glowna');
        say(actionStatus, r.ok ? jst("pages_moj_raport_liczb_js.literal.7c513eb664e1") : jst("pages_moj_raport_liczb_js.literal.d84fe6776ebb"),
          r.ok ? jst("ui.e0589c2fa395e29a") : jst("ui.0fe0e61cf1341d74"));
      });
    }
    box.querySelectorAll('[data-mr-highlight]').forEach(function (b) { b.disabled = false; b.addEventListener('click', function () { highlight(Number(b.getAttribute('data-mr-highlight'))); }); });
    var source = box.querySelector('[data-mr-data]');
    try { if (source) chartData = JSON.parse(source.getAttribute('data-mr-data')); } catch (ignore) {}
    if (!chartData) return;
    var ns = 'http://www.w3.org/2000/svg';
    function svgEl(tag, attrs, text) {
      var e = doc.createElementNS(ns, tag);
      Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, String(attrs[k])); });
      if (text !== undefined) e.textContent = String(text);
      return e;
    }
    function chart(el) {
      var kind = el.getAttribute('data-mr-chart');
      var rows = kind === 'freq' ? chartData.freq : chartData.historia;
      if (!rows.length) return;
      var step = kind === 'freq' ? 52 : 8;
      var width = Math.max(360, 50 + rows.length * step);
      var height = 230, top = 25, bottom = 180;
      var max = Math.max(1, chartData.oczekiwane, Math.max.apply(null, rows.map(function (r) { return r.hits; })), Math.max.apply(null, chartData.historia_b.map(function (r) { return r.hits; })));
      var svg = svgEl('svg', {width: width, height: height, role: kind === 'freq' ? 'group' : 'img', 'aria-label': el.getAttribute('aria-label')});
      // Fixed pixel width keeps labels readable on mobile; the wrapper scrolls.
      svg.classList.add('raport-wykres');
      svg.appendChild(svgEl('line', {x1:35,y1:bottom,x2:width-10,y2:bottom,stroke:'currentColor'}));
      function y(v) { return bottom - v / max * (bottom - top); }
      [0, max].forEach(function (v) { svg.appendChild(svgEl('text', {x:2,y:y(v)+4,'font-size':12,fill:'currentColor'}, Number(v.toFixed(1)))); });
      if (kind === 'freq') {
        rows.forEach(function (r,i) {
          var x=42+i*step;
          var g=svgEl('g', {role:'button',tabindex:0,'aria-label':(jst("pages_moj_raport_liczb_js.f117508eed86"))+r.n+'; '+r.hits+(jst("pages_moj_raport_liczb_js.6ab9624f8848"))});
          g.appendChild(svgEl('rect',{x:x-4,y:top,width:44,height:height-top-5,fill:'transparent'}));
          g.appendChild(svgEl('rect',{x:x,y:y(r.hits),width:32,height:bottom-y(r.hits),fill:'var(--kolor-'+game+jst("fragment.90025fc587fededc"),stroke:'currentColor'}));
          g.appendChild(svgEl('text',{x:x+16,y:bottom+22,'text-anchor':'middle','font-size':12,fill:'currentColor'},r.n));
          g.appendChild(svgEl('text',{x:x+16,y:y(r.hits)-5,'text-anchor':'middle','font-size':12,fill:'currentColor'},r.hits));
          g.addEventListener('click',function(){highlight(r.n);});
          g.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();highlight(r.n);}});
          svg.appendChild(g);
        });
      } else {
        var A=rows.map(function(r,i){return (42+i*step)+','+y(r.hits);}).join(' ');
        svg.appendChild(svgEl('polyline',{points:A,fill:'none',stroke:'var(--kolor-'+game+jst("fragment.90025fc587fededc"),'stroke-width':2}));
        if(chartData.historia_b.length) svg.appendChild(svgEl('polyline',{points:chartData.historia_b.map(function(r,i){return (42+i*step)+','+y(r.hits);}).join(' '),fill:'none',stroke:'currentColor','stroke-width':2,'stroke-dasharray':'5 4'}));
        rows.forEach(function(r,i){var point=svgEl('circle',{cx:42+i*step,cy:y(r.hits),r:2,fill:'currentColor'});point.appendChild(svgEl('title',{},'#'+r.id+' · '+r.data+' · A: '+r.hits+(chartData.historia_b.length?' · B: '+chartData.historia_b[i].hits:'')));svg.appendChild(point);});
        svg.appendChild(svgEl('text',{x:42,y:bottom+22,'font-size':12,fill:'currentColor'},(jst("pages_moj_raport_liczb_js.abf7dbef2dbc"))+' #'+rows[0].id));
        svg.appendChild(svgEl('text',{x:width-10,y:bottom+22,'text-anchor':'end','font-size':12,fill:'currentColor'},(jst("pages_moj_raport_liczb_js.d031454be8fe"))+' #'+rows[rows.length-1].id));
        svg.appendChild(svgEl('text',{x:42,y:bottom+42,'font-size':12,fill:'currentColor'},jst("pages_moj_raport_liczb_js.2caafff83655")));
      }
      el.appendChild(svg);
    }
    var charts=box.querySelectorAll('[data-mr-chart]');
    if (root.IntersectionObserver) {
      var observer=new root.IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){observer.unobserve(e.target);chart(e.target);}});},{rootMargin:'100px'});
      charts.forEach(function(el){observer.observe(el);});
    } else charts.forEach(chart);
  }
  if (doc.readyState !== 'complete') doc.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
